import React from "react";

import { useNavigate, useParams } from "react-router";

import { Divider, Typography } from "@mui/material";

import ActionBar from "@app/analytics/components/ActionBar";
import {
  IntegrationsContent,
  IntegrationsPageContainer,
} from "@app/analytics/Integrations/styles";
import useResponsiveView from "@app/common/hooks/useResponsiveView";
import ROUTES from "@app/common/routes";

import { Column, DesktopOnlyRow, MobileOnlyRow, Row } from "@rui/Stack";
import { BackButton } from "@rui/styles";

import IntegrationDetail from "./IntegrationDetail";
import IntegrationsList from "./IntegrationsList";
import { getSelectedTab, getTabs } from "./utils";

const getBackButtonRoute = (scope?: string) =>
  scope === "workspace"
    ? ROUTES.INTEGRATIONS_WORKSPACE_ROOT
    : ROUTES.INTEGRATIONS_USER_ROOT;

const Integrations = () => {
  const navigate = useNavigate();
  const { scope } = useParams();
  const { inMobileView } = useResponsiveView();

  const tabs = getTabs(inMobileView);
  const { selectedTab, selectedTabConfig } = getSelectedTab(scope, tabs);

  const handleBackToIntegrationsClick = () => {
    navigate(getBackButtonRoute(scope));
  };

  return (
    <IntegrationsPageContainer>
      <DesktopOnlyRow sx={{ display: "contents" }}>
        <ActionBar>
          <Row variant="left" spacing={1}>
            <BackButton onClick={() => navigate(-1)} />
            <Divider orientation="vertical" sx={{ height: "20px", mr: 1 }} />
            <Typography variant="h2">Apps & Integrations</Typography>
          </Row>
        </ActionBar>
      </DesktopOnlyRow>
      <IntegrationsContent>
        <DesktopOnlyRow>
          <IntegrationsList />
        </DesktopOnlyRow>
        <Column flex={1}>
          <MobileOnlyRow
            spacing={1}
            alignItems="center"
            paddingY={1.5}
            paddingX={3}
          >
            <BackButton onClick={handleBackToIntegrationsClick} />
            <Typography variant="bodyPrimaryMed">
              {selectedTabConfig?.label}
            </Typography>
          </MobileOnlyRow>
          <IntegrationDetail scope={selectedTab} />
        </Column>
      </IntegrationsContent>
    </IntegrationsPageContainer>
  );
};

export default Integrations;
